import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';
import { fetchSecurityQuestions } from '@/lib/api/SecurityQuestion';

import { recoveryAccount } from '@/lib/api/Users';


import PassModal from './PasswordModal';

const ForgotPasswordFlow = () => {
  const [step, setStep] = useState(1);
  const [step2Initialized, setStep2Initialized] = useState(false);
  const [email, setEmail] = useState('');
  const [allQuestions, setAllQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState(Array(5).fill(''));
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassModal, setShowPassModal] = useState(false);

  useEffect(() => {
    if (step === 2 && !step2Initialized) {
      const loadQuestions = async () => {
        try {
          const response = await fetchSecurityQuestions();
          setAllQuestions(response);
          setStep2Initialized(true);
        } catch (error) {
          console.error(error);
          alert('Failed to load security questions. Please try again later.');
        }
      };
      loadQuestions();
    }
  }, [step, step2Initialized]);

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      alert('Please enter a valid email');
      return;
    }
    setStep(2);
  };

  const handleQuestionChange = (index, questionId) => {
    const updated = [...selectedQuestions];
    updated[index] = questionId;
    setSelectedQuestions(updated);
  };

  const handleAnswerChange = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  const handleSecuritySubmit = async (e) => {
    e.preventDefault();
    if (
      selectedQuestions.includes('') ||
      selectedQuestions.some((qId) => !answers[qId] || answers[qId].trim() === '')
    ) {
      alert('Please select and answer all 5 security questions.');
      return;
    }

    setLoading(true);
    try {
      const result = await recoveryAccount({
        email,
        selectedQuestions,
        answers,
      });

      localStorage.setItem('authToken', result.access_token);
      localStorage.setItem('tokenType', result.token_type);

      alert('Account recovery successful! Please set your new password.');
      setShowPassModal(true);
    } catch (error) {
      console.error(error);
      alert('Recovery failed: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{ backgroundColor: '#e96208e0' }}
    >      <HTopbar />

      <div className="flex-grow-1 d-flex flex-column flex-md-row">
        {/* Left Visual */}
        <div className="d-none d-md-flex w-md-50 h-100">
          <img
            src={step === 1 ? '/images/login.png' : '/images/login.jpg'}
            alt="Visual"
            className="img-fluid w-100 h-100"
            style={{ objectFit: 'cover' }}
          />
        </div>

        {/* Right Form */}
        <div
          className="w-100 w-md-50 d-flex p-4"
          style={{
            minHeight: 'calc(100vh - 56px)', // adjust for topbar height
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            className="card shadow-lg p-4 w-100"
            style={{ maxWidth: '500px', borderRadius: '1rem' }}
          >
            <div className="card-body text-center">
              <h1 className="fw-bold text-dark mb-3" style={{ fontSize: '2rem' }}>
                MATCH
                <br />
                UP
              </h1>

              {step === 1 && (
                <form onSubmit={handleEmailSubmit}>
                  <p className="text-dark fs-5 mb-1">Forgot your password?</p>
                  <p className="text-secondary mb-4">
                    Enter your email address below and we'll send you a reset link.
                  </p>

                  <div className="mb-3">
                    <input
                      type="email"
                      className="form-control form-control-lg border border-secondary-subtle text-center"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <button type="submit" className="btn btn-dark btn-lg w-100 fw-bold" disabled={loading}>
                    Next
                  </button>
                </form>
              )}

              {step === 2 && (
                <>
                  <p className="text-muted mb-3">
                    Choose and answer 5 security questions to recover your account.
                  </p>

                  {allQuestions.length === 0 ? (
                    <p className="text-muted">Loading questions...</p>
                  ) : (
                    <form onSubmit={handleSecuritySubmit}>
                      {selectedQuestions.map((selectedId, index) => (
                        <div key={index} className="mb-3 text-center">
                          <label className="form-label text-muted mb-1 d-block">
                            {index + 1}. Choose a security question
                          </label>
                          <select
                            className="form-select mb-2 text-center"
                            value={selectedId}
                            onChange={(e) => handleQuestionChange(index, e.target.value)}
                          >
                            <option value="">-- Select a question --</option>
                            {allQuestions.map((q) => (
                              <option key={q.id} value={q.id} disabled={selectedQuestions.includes(q.id)}>
                                {q.question_text}
                              </option>
                            ))}
                          </select>
                          {selectedId && (
                            <input
                              type="text"
                              className="form-control text-center"
                              placeholder="Your answer"
                              value={answers[selectedId] || ''}
                              onChange={(e) => handleAnswerChange(selectedId, e.target.value)}
                            />
                          )}
                        </div>
                      ))}

                      <button type="submit" className="btn btn-dark btn-lg w-100 mt-3" disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit Answers'}
                      </button>
                    </form>
                  )}
                </>
              )}
            </div>
          </div>
        </div>



      </div>

      <PassModal show={showPassModal} onClose={() => setShowPassModal(false)} />
    </div>
  );
};

export default ForgotPasswordFlow;
